import { render, staticRenderFns } from "./PotentialInterest.vue?vue&type=template&id=6c9a0683"
import script from "./PotentialInterest.vue?vue&type=script&lang=js"
export * from "./PotentialInterest.vue?vue&type=script&lang=js"
import style0 from "./PotentialInterest.vue?vue&type=style&index=0&id=6c9a0683&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports